import {svgSprite} from '../utils/IconsPath';

export function getSvg(name) {
    return `<svg><use xlink:href="${svgSprite}#${name}"></use></svg>`;
}

export class IconController {
    constructor(root, params = {}) {
        this._root = root;
        this._updateParams(params);
    }

    initialize() {
        const name = this._iconName();
        if (name) {
            this._root.innerHTML = getSvg(name);
            this._root.classList.add('joy-i_loaded');
        }
    }

    destroy() {
        this._root = null;
        this._params = null;
    }

    refreshParams(params = {}) {
        this._updateParams(params);
        this._clear();
        this.initialize();
    }

    _updateParams(params) {
        this._params = Object.assign(this._params || {}, params);
    }

    _clear() {
        this._root.innerHTML = '';
        this._root.classList.remove('joy-i_loaded');
    }

    _iconName() {
        return this._params.name;
    }
}
